import { AutoSuggestSymbol } from './symbol-lookup.domain';

export interface SecuritiesTransfersSymbol extends AutoSuggestSymbol {
  eligibility?: boolean;
  transferToken?: string;
  securityId?: string;
}

export const TRANSFERS_TABS = ['cash', 'securities', 'ofi', 'holdings'] as const;
export type TransfersTab = typeof TRANSFERS_TABS[number];
export enum TransfersHelpArticleId {
  SECURITY_TRANSFERS = 'security_transfers',
  TRAN_ENTER = 'tran_enter',
  TRAN_REVIEW = 'tran_review',
  TRAN_CONFIRMATION = 'tran_confirmation',
  OFI_TRANSFERS = 'ofi_transfers'
}
